import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * A rig type's BrewBase-owned documents: the wiring itself (index) and the
 * calibration targets written in its alias vocabulary. Both share the fleet
 * sidebar, set by each page rather than here (see useFleetSidebar).
 */
export const Route = createFileRoute("/brewcontrol/wirings/$modelId")({
  component: Outlet,
});
